import styled from 'styled-components';
export const FingerSize = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	
	padding: 20px 10px;

	min-height: min-content;
	min-width: 0px;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		padding: 0px 10px;
	}
`;

export const DimensionsSliders = styled.div`
	@media (min-height: ${(props) => props.theme.mediaQueryConstants.veryLowHeight + 1}px) {
		padding: 20px 0px;
	};
`;

export const SliderContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: 20px;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		padding: 5px 20px;
	};
`;

export const IconWithTitle = styled.div`
	font-weight: 700;
	font-size: 12px;
	line-height: 15px;
	letter-spacing: 0.03em;
	color: #444449;
	
	min-width: 70px;
	
	display: flex;
	flex-direction: column;    
`;

export const SliderTitle = styled.div`
	font-weight: 700;
	font-size: 12px;
	line-height: 15px;
	letter-spacing: 0.03em;
	color: #444449;
	margin-bottom: 8px;
`;

export const SwitchContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	
	margin-top: 40px;
	margin-bottom: 60px;
	    
	font-style: normal;
	font-weight: 500;
	font-size: 12px;

	padding: 0px 20px;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		margin-top: 5px;
		margin-bottom: 5px;
	}
`;

export const Notification = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 225px;
`;

export const InfoIcon = styled.div`
	width: 40px;
	margin-right: 15px;
`;

export const Info = styled.div`
	max-width: 190px;
`;


export const ShapeContainer = styled.div`
	display: flex;
	margin-bottom: 85px;
`;

export const ShapeWrapper = styled.div`
	display: flex;
	flex-direction: column;
    align-items: center;
	gap:5px;
	flex:1;
`;

export const ShapeTitle = styled.div`
	font-weight: 700;
	opacity:${({ isActive }) => isActive ? .85 : .35};
	cursor:pointer;
`;

export const Image = styled.img`
  width: ${({ width = 100 }) => `${width}px`};
  height: ${({ height = 50 }) => `${height}px`};
  object-fit: cover;
  cursor:pointer;
`;